export function captureUtmSource(search) {
  const source = new URLSearchParams(search).get('utm_source');

  if (source && !localStorage.getItem('source')) {
    localStorage.setItem('source', source);
  }
}

export function addReferrerAndSource(payload) {
  const referrer = localStorage.getItem('referrer');
  if (referrer) payload.referrer = referrer;

  const source = localStorage.getItem('source');
  if (source) payload.source = source;
}

export function buildAuthNavigationPath(pathname, search, email) {
  const queryParams = new URLSearchParams(search);

  if (email) queryParams.set('email', email);
  else queryParams.delete('email');

  const query = queryParams.toString();
  return query ? `${pathname}?${query}` : pathname;
}

export function getSafeRedirectPath(value) {
  if (typeof value !== 'string' || value.startsWith('//')) return null;

  try {
    const isInternalPath = value.startsWith('/');
    if (!isInternalPath && !/^https?:\/\//i.test(value)) return null;

    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    if (/^\/partner-redirect(?:\/|$)/i.test(url.pathname)) return null;

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
